import React, { useState, useEffect } from 'react';

const Stats = () => {
    const [counters, setCounters] = useState([
        {
            id: 1,
            label: 'Years Experience',
            value: 20,
            suffix: '+',
            current: 0,
            context: 'Fintech, Retail & AI Leadership',
            details: 'Over two decades of experience leading product and technology teams across American Express, Nordstrom, and Amazon. Specialized in building large-scale enterprise solutions and empowering cross-functional teams.'
        },
        {
            id: 2,
            label: 'Agentic AI Platform',
            value: 100,
            suffix: '%',
            current: 0,
            context: 'ACE Platform @ American Express',
            details: 'Leading enterprise AI platform strategy across Agentic AI, Durable Workflows (AWN, LangGraph, ACE MOD Registry), Human-in-the-Loop governance, Multimodal Conversational Agents, and AI-powered Knowledge Management.'
        },
        {
            id: 3,
            label: 'Annual Planning',
            value: 10,
            suffix: 'B+',
            current: 0,
            prefix: '$',
            context: 'Nordstrom Merchandise Financial Planning',
            details: 'At Nordstrom, led Merchandise Financial Planning applications to strategically manage and plan over $10 Billion worth of merchandise inventory per year, bridging complex financial goals with technical execution.'
        },
        {
            id: 4,
            label: 'Users Impacted',
            value: 200,
            suffix: 'M+',
            current: 0,
            context: 'Global Prime Member Reach',
            details: 'Work impacts a massive global user base, including over 200 Million Amazon Prime members worldwide who benefit from the payments and financial products shaped and delivered.'
        }
    ]);

    const [selectedStat, setSelectedStat] = useState(null);

    useEffect(() => {
        const duration = 2000;
        const interval = 20;
        const steps = duration / interval;

        const timer = setInterval(() => {
            setCounters(prevCounters => {
                const nextCounters = prevCounters.map(counter => {
                    if (counter.current >= counter.value) return counter;

                    const increment = counter.value / steps;
                    const nextValue = Math.min(counter.current + increment, counter.value);

                    return { ...counter, current: nextValue };
                });

                if (nextCounters.every(c => c.current >= c.value)) {
                    clearInterval(timer);
                }
                return nextCounters;
            });
        }, interval);

        return () => clearInterval(timer);
    }, []);

    return (
        <div className="row stats-row">
            <div className="stats-container">
                {counters.map(counter => (
                    <div key={counter.id} className="stats-col">
                        <div className="stats-card" onClick={() => setSelectedStat(counter)}>
                            <div className="stats-number">
                                {counter.prefix}{Math.floor(counter.current)}{counter.suffix}
                            </div>
                            <div className="stats-label">{counter.label}</div>
                            <div className="stats-context">{counter.context}</div>
                            <div className="stats-hint"><i className="fa fa-info-circle"></i> View Details</div>
                        </div>
                    </div>
                ))}
            </div>

            {selectedStat && (
                <div className="stats-modal-overlay" onClick={() => setSelectedStat(null)}>
                    <div className="stats-modal" onClick={e => e.stopPropagation()}>
                        <button className="stats-close" onClick={() => setSelectedStat(null)}>&times;</button>
                        <h3>{selectedStat.label}</h3>
                        <div className="stats-modal-number">
                            {selectedStat.prefix}{selectedStat.value}{selectedStat.suffix}
                        </div>
                        <p>{selectedStat.details}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Stats;
